import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vuex from 'vuex'
import ElementUI from 'element-ui'
import echarts from 'echarts'
import { message } from '@/common/ResetMessage'
// 下面两行为了设置table的默认border属性
import { Table } from 'element-ui'

import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import './assets/css/public.css'
import createStore from './store/store'

Vue.use(ElementUI)
Vue.use(Vuex)

const store = createStore()
const hasPermission = (userPermission) => {
  // let btnPermissionList = store.getters.getButtonList
  let btnPermissionList = JSON.parse(localStorage.getItem('buttonList'))
  // let status = btnPermissionList.includes(userPermission)
  let path = userPermission.split('||')
  let status = false
  let pathLen = path.length
  for (var i = 0; i < pathLen; i++) {
    let tmpPath = path[i].replace(/^"|'|\s+/g, '')
    if (btnPermissionList.includes(tmpPath)) {
      status = true
      break
    }
  }
  return status
}
Vue.directive('has', {
  inserted: function (el, binding) {
    if (!hasPermission(binding.expression)) {
      el.parentNode.removeChild(el)
    }
  }
})

Vue.prototype.$echarts = echarts
Vue.prototype.$message = message
// 设置table的默认属性
Table.props.border.default = true;

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
